<app-header [ngClass]="{'d-none': hideHeaderAndFooter}"></app-header>
<router-outlet></router-outlet>
<app-spinner></app-spinner>

<app-notifier></app-notifier>

<!--
<app-footer [ngClass]="{'d-none': hideHeaderAndFooter}"></app-footer>
-->
